import { gql } from '@apollo/client';

export const CREATE_STYLE = gql`
    mutation createStyle($input: CreateStyleInput!) {
        createStyle(input: $input) {
            id
            creator
            created
            updater
            updated
            taffiId
            title
            description
            images
            categories {
                id
                name
            }
            tags {
                id
                name
            }
            items {
                id
            }
            genders {
                id
            }
            purposes {
                id
            }
            ages {
                id
            }
            seasons {
                id
            }
            status
        }
    }
`;
export const UPDATE_STYLE = gql`
    mutation updateStyle($input: UpdateStyleInput!) {
        updateStyle(input: $input) {
            id
            creator
            created
            updater
            updated
            taffiId
            consumersId
            consumers {
                id
                firstName
                lastName
            }
            title
            description
            images
            imageJson
            categories {
                id
                name
            }
            tags {
                id
                name
            }
            items {
                id
                data {
                    localId
                    itemCodes
                    creator
                    accessLevel
                    brand {
                        id
                        name
                        value
                        imageUrl
                    }
                    colors {
                        id
                        title
                        value
                        subject
                    }
                    sizes {
                        id
                        title
                        value
                        subject
                    }
                    id
                    taffiId
                    collection
                    price
                    currency
                    available
                    title
                    description
                    categories {
                        id
                        name
                    }
                    tags {
                        id
                        name
                    }
                    labels {
                        id
                        name
                    }
                    url
                    images
                    storeId
                    storeProductId
                    user {
                        userType
                        firstName
                        lastName
                    }
                }
                variant {
                    color
                    size
                }
            }
            genders {
                id
            }
            purposes {
                id
            }
            ages {
                id
            }
            seasons {
                id
            }
            personas {
                id
            }
            status
        }
    }
`;
export const UPDATE_IMAGE_JSON_STYLE = gql`
    mutation updateImageJsonStyle($input: UpdateStyleInput!) {
        updateStyle(input: $input) {
            id
            imageJson
            status
        }
    }
`;
export const UPLOAD_BASE_64 = gql`
    mutation uploadFileBase64($input: UploadFileBase64Input!) {
        uploadFileBase64(input: $input) {
            url
        }
    }
`;
